<template>

  <div class="col-lg-12 card515 transition-in-image w-100">
    <div class=" w-100">
      <div class="w-100 row ">

        <div class="col-8 card515-p-1-position">
          <div data-slot="p-1">
            <slot name="p-1"/>
          </div>
        </div>


        <div class="col-4 p-0 card515-p-2-position">
          <div class="icon-style" data-slot="p-2">
            <slot name="p-2"/>
          </div>
        </div>

      </div>
    </div>
  </div>

</template>

<script>
export default {
  name: 'Card515',
};
</script>

<style>
.transition-in-image > div .icon-style * {
  transition: 0.2s;
}

.transition-in-image:hover > div .icon-style * {
  transform: scale(1.08);
  margin-right: 14px;
  transition: 0.2s;
}
</style>
<style scoped>

</style>
